import { IResourceComponentsProps } from '@pankod/refine-core';
import { CustomPage } from '../../components/customPage';

export const Dashboard: React.FC<IResourceComponentsProps> = () => {
  return (
    <CustomPage>
      <div>Dashboard</div>
    </CustomPage>
  );
};
